import { Component, Input, OnInit } from '@angular/core';
import { LetterRequestCustomer_Cancel } from 'src/app/Interface/LetterRequestCustomer_Cancel';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { LetterRequestCustomerService } from 'src/app/Service/Letter/LetterRequestCustomer.service';

@Component({
  selector: 'app-LetterRequestCustomerMissionActivityRelative',
  templateUrl: './LetterRequestCustomerMissionActivityRelative.component.html',
  styleUrls: ['./LetterRequestCustomerMissionActivityRelative.component.scss']
})
export class LetterRequestCustomerMissionActivityRelativeComponent implements OnInit {


  @Input() inner_Schedule_id: number = 0
  Token: String = ""
  Filter_Letter: String = ""
  Procssing:boolean=false

  constructor(
    private LetterRequestCustomer_Service: LetterRequestCustomerService,
    private Alertify_Service: AlertifyService,
  ) { }

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');
    this.ReadData_Schedules()
  }


  SubmitSchedulesRelative(){
    this.Procssing=true
    this.LetterRequestCustomer_Service.SubmitSchedulesRelative(Number(this.Filter_Letter),this.inner_Schedule_id,this.Token).subscribe(
      data=>{
        this.Procssing=false
        if(data['id']==-1)
        {
          this.Alertify_Service.ErrorMessage("The assignment order number is invalid.")
        }
        else{
          this.Alertify_Service.SuccessMessage("The association was applied successfully.")
          this.ReadData_Schedules()
        }
      }
    )
  }

  DataList_Schedules:Array<LetterRequestCustomer_Cancel>=[]
  ReadData_Schedules(){
    this.Procssing=true

    this.LetterRequestCustomer_Service.GetSchedulesRelative(this.Token,this.inner_Schedule_id).subscribe(
      data=>{
        this.DataList_Schedules=data
        this.Procssing=false
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  RemoveSchedulesRelative(){
    this.Procssing=true
    this.LetterRequestCustomer_Service.RemoveSchedulesRelative(this.inner_Schedule_id,this.Token).subscribe(
      data=>{
        this.Procssing=false
        if(data['id']==-1)
        {
          this.Alertify_Service.ErrorMessage("This association cannot be deleted.")
        }
        else{
          this.Alertify_Service.SuccessMessage("The association was deleted successfully.")
          this.ReadData_Schedules()
        }
      }
    )
  }


}
